import React from "react";
import { Page } from "react-onsenui";
import Substance from "../components/substance/Substance";
import Toolbar from "../components/Toolbar";

class SubstancePage extends React.Component {
  renderToolbar() {
    const { navigator, substance } = this.props;
    return <Toolbar pageName={substance.name} navigator={navigator} />;
  }

  render() {
    const { substance } = this.props;

    return (
      <Page renderToolbar={this.renderToolbar.bind(this)}>
        <Substance substance={substance} />
      </Page>
    );
  }
}

export default SubstancePage;
